import { gql } from '@apollo/client';

/* Spread by TEAM_QUERY, USER_QUERY and INITIAL_QUERY, so `plan` rides bootstrap too: a gateway
   without `Team.plan` fails those documents outright, not just the tier. */
const TEAM_META_FRAGMENT = gql`
  fragment teamMeta on Team {
    team_id
    name
    logo
    currency
    number_format
    plan
  }
`;
export { TEAM_META_FRAGMENT };
